import api from '../api/axios';

const getAll = (withDeleted = false) => {
  return api.get(`/payment-methods?withDeleted=${withDeleted}`);
};

const getActive = () => {
  return api.get('/payment-methods/active/list');
};

const getById = (id) => {
  return api.get(`/payment-methods/${id}`);
};

const create = (item) => {
  return api.post('/payment-methods', item);
};

const update = (id, updatedItem) => {
  return api.patch(`/payment-methods/${id}`, updatedItem);
};

const remove = (id) => {
  return api.delete(`/payment-methods/${id}`);
};

const reorder = (items) => {
  return api.patch('/payment-methods/reorder/batch', items);
};

const paymentMethodsServices = {
  getAll,
  getActive,
  getById,
  create,
  update,
  remove,
  reorder,
};

export default paymentMethodsServices;
